import * as Yup from 'yup';

export const GroupFormSchema = Yup.object().shape({
  name: Yup.string()
    .required('Required'),
  users: Yup.array().min(1),
});
